/**
 * Configuración de ejemplo para el Dashboard de Neurolimpiadas
 * 
 * Este archivo muestra todas las opciones de configuración disponibles.
 * La configuración real se almacena automáticamente en localStorage.
 */

// Configuración por defecto del Timer
export const DEFAULT_TIMER_CONFIG = {
  minutes: 2,              // Minutos iniciales
  seconds: 0,               // Segundos iniciales
  title: "Tiempo de Competencia",
  categories: [
    { id: "1", name: "Animales terrestres", minutes: 2, seconds: 0 },
    { id: "2", name: "Animales acuáticos", minutes: 2, seconds: 0 },
    { id: "3", name: "Países", minutes: 2, seconds: 0 },
    { id: "4", name: "Profesiones", minutes: 2, seconds: 0 },
    { id: "5", name: "Lugares", minutes: 2, seconds: 0 },
    { id: "6", name: "Flora", minutes: 2, seconds: 0 },
    { id: "7", name: "Nombres femeninos", minutes: 2, seconds: 0 },
    { id: "8", name: "Nombres masculinos", minutes: 2, seconds: 0 },
    { id: "9", name: "Partes del cuerpo", minutes: 2, seconds: 0 },
    { id: "10", name: "Alimentos", minutes: 2, seconds: 0 },
    { id: "11", name: "Prendas de vestir", minutes: 2, seconds: 0 },
    { id: "12", name: "Verbos", minutes: 2, seconds: 0 }
  ] as Array<{
    id: string;
    name: string;
    minutes: number;
    seconds: number;
  }>
};

// Configuración por defecto del Bracket
export const DEFAULT_BRACKET_CONFIG = {
  title: "NEUROTEIDE",
  teams: [
    "Equipo Alpha",
    "Equipo Beta", 
    "Equipo Gamma",
    "Equipo Delta",
    "Equipo Epsilon",
    "Equipo Zeta",
    "Equipo Eta",
    "Equipo Theta"
  ]
};

// Configuración por defecto del Leaderboard
export const DEFAULT_LEADERBOARD_CONFIG = {
  title: "Clasificacion general",
  phaseNames: {
    phase1: "Relevos",
    phase2: "Aro Canario", 
    phase3: "Cifras y Letras",
    phase4: "Figuras de Colores",
    phase5: "Pizarra"
  },
  teams: [
    { 
      name: "Baltalímpicas", 
      phases: { phase1: 78, phase2: 75, phase3: 73, phase4: 0, phase5: 0 }, 
      total: 226 
    },
    { 
      name: "El Roque", 
      phases: { phase1: 78, phase2: 75, phase3: 55, phase4: 0, phase5: 0 }, 
      total: 208 
    },
    { 
      name: "La Unión", 
      phases: { phase1: 78, phase2: 0, phase3: 55, phase4: 0, phase5: 0 }, 
      total: 133 
    },
    { 
      name: "Todoque", 
      phases: { phase1: 60, phase2: 0, phase3: 73, phase4: 0, phase5: 0 }, 
      total: 133 
    },
    { 
      name: "Ciclón", 
      phases: { phase1: 60, phase2: 0, phase3: 73, phase4: 0, phase5: 0 }, 
      total: 133 
    }
  ]
};

// Configuración por defecto del Carousel
export const DEFAULT_CAROUSEL_CONFIG = {
  autoPlay: true,           // Reproducción automática
  interval: 5000,          // Intervalo en milisegundos
  media: [
    {
      id: "1",
      type: "image",
      url: "/images/slide1.jpg",
      duration: 5000
    },
    {
      id: "2",
      type: "image", 
      url: "/images/slide2.jpg",
      duration: 5000
    }
  ]
};

// Configuración del sistema de comunicación
export const SYSTEM_CONFIG = {
  // Prefijo para todas las claves de localStorage
  STORAGE_PREFIX: "neurolimpiadas_",
  
  // Tiempo de vida de los eventos en localStorage (ms)
  EVENT_TTL: 5000,
  
  // Intervalo del timer global (ms)
  TIMER_INTERVAL: 1000,
  
  // Configuración de ventanas emergentes
  WINDOW_OPTIONS: "width=1920,height=1080,scrollbars=yes,resizable=yes"
};

// Eventos disponibles para comunicación entre ventanas
export const COMMUNICATION_EVENTS = {
  // Configuración
  CONFIG_UPDATE: "configUpdate",
  
  // Timer
  TIMER_START: "timerStart",
  TIMER_PAUSE: "timerPause", 
  TIMER_RESET: "timerReset",
  TIMER_TICK: "timer-tick",
  TIMER_FINISHED: "timer-finished",
  
  // Bracket
  BRACKET_UPDATE: "bracketUpdate",
  BRACKET_RESET: "bracketReset",
  
  // Leaderboard
  LEADERBOARD_UPDATE: "leaderboardUpdate",
  LEADERBOARD_RESET: "leaderboardReset",
  
  // Carousel
  CAROUSEL_PLAY: "carouselPlay",
  CAROUSEL_PAUSE: "carouselPause",
  CAROUSEL_NEXT: "carouselNext",
  CAROUSEL_PREV: "carouselPrev"
};

// Configuración de desarrollo
export const DEV_CONFIG = {
  // Mostrar logs detallados
  VERBOSE_LOGGING: true,
  
  // Simular latencia para testing
  SIMULATE_DELAY: false,
  DELAY_MS: 100,
  
  // Limpiar localStorage al inicio
  CLEAR_STORAGE_ON_START: false
};
